import React from 'react';
import AppModal from '../../components/AppModal/AppModal';
import { useOnboarding } from '../../contexts/OnboardingContext';
import './Onboarding.css';

// One-time welcome modal offering a guided first draft, self-exploration,
// or the tutorial video. Never shown again after a choice is made.
function WelcomeModal() {
    const { showWelcome, videoUrl, chooseWelcome } = useOnboarding();

    return (
        <AppModal
            isOpen={showWelcome}
            title="Welcome to Alchemiq"
            maxWidth={440}
            footer={null}
            modalTestId="onboarding-welcome-modal"
        >
            <p style={{ margin: 0, color: '#3C4A5E', fontSize: 14, lineHeight: 1.5 }}>
                Create your first story in four steps. Find a trend, choose the evidence,
                review the facts, and generate a draft.
            </p>
            <div className="onb-welcome-options">
                <button
                    type="button"
                    className="onb-welcome-primary"
                    onClick={() => chooseWelcome('guided')}
                >
                    Start a guided first draft
                </button>
                {videoUrl && (
                    <a
                        className="onb-welcome-secondary"
                        href={videoUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => chooseWelcome('video')}
                    >
                        Watch the 2-minute video
                    </a>
                )}
                <button
                    type="button"
                    className="onb-welcome-secondary"
                    onClick={() => chooseWelcome('explore')}
                >
                    Explore on my own
                </button>
            </div>
        </AppModal>
    );
}

export default WelcomeModal;
